import { SvgIconProps } from './icon-props';

export default function ExpandIcon({ height = 6, width = 11, className }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 11 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M1.38584 0.0600586L0 0.0630759L5.5059 5.06006L11 0.0630759L1.38584 0.0600586Z"
				fill="#030303"
			/>
		</svg>
	);
}
